/**
 * Slices an array of stops to show at most 25 stops,
 * centering around the pending stop if possible.
 *
 * @param {Array} stops - All stops in the route
 * @param {string|number} pendingId - ID of the stop being assigned
 * @returns {Array} - The sliced array of stops
 */
export const getSlicedStops = (stops, pendingId) => {
  if (!stops || stops.length <= 25) return stops || []

  const pendingIndex = stops.findIndex(
    s => s.isPending || s.toBeInserted || String(s.id) === String(pendingId) || String(s.workOrderId) === String(pendingId)
  )

  const centerIndex = pendingIndex !== -1 ? pendingIndex : 0
  let start = Math.max(0, centerIndex - 12)
  const end = Math.min(stops.length, start + 25)

  // Adjust if we are near the end
  if (end - start < 25) {
    start = Math.max(0, end - 25)
  }

  return stops.slice(start, end)
}
